import VueGtag, { trackRouter } from 'vue-gtag-next';
import { useInteractiveStore } from '~/stores/interactive';

export default defineNuxtPlugin((nuxtApp) => {
  const interactiveStore = useInteractiveStore();
  if (interactiveStore.isPageSpeedBot) return;
  const init = () => {
    const tag_id = import.meta.env.GOOGLE_TAG_MANAGER_ID
      ? import.meta.env.GOOGLE_TAG_MANAGER_ID.toString()
      : 'GTM-5QVZ96';
    const runtimeConfig = useRuntimeConfig();
    const isProd = runtimeConfig.public.isProd;
    if (isProd) {
      nuxtApp.vueApp.use(VueGtag, {
        property: {
          id: tag_id,
        },
      });
      trackRouter(useRouter());
    }
  };
  interactiveStore.addFunction(init);
});
